import React from "react";
import axios from "axios";
import Config from "../config";

export default function connectPhotos(Component, options = {}) {
  const reverse = options.reverse;

  return class ConnectedPhotos extends React.Component {
    state = {
      photos: null,
      allPhotos: null
    };

    async componentDidMount() {
      this._isMounted = true;

      const response = await axios.get(Config.API + "/ohZe1CiQBe6Pu9/images");

      if (!this._isMounted) return;

      const allPhotos = response.data.map(photo => ({
        key: photo.uuid,
        src: Config.IMAGE + "/ohZe1CiQBe6Pu9/images/" + photo.uuid + ".jpg",
        thumbnail: Config.IMAGE + "/ohZe1CiQBe6Pu9/images/" + photo.uuid + "-mini.jpg",
        width: Math.trunc(photo.width / 100),
        height: Math.trunc(photo.height / 100)
      }));

      if (options.animate) {
        this.setState({ allPhotos, photos: allPhotos.slice(0, options.startCount || 0) });
        this.animatePhotos();
      } else {
        this.setState({ allPhotos, photos: allPhotos });
      }
      // this.animatePhotos()
    }

    animatePhotos() {
      setTimeout(() => {
        if (this.state.photos.length < this.state.allPhotos.length) {
          if (!this._isMounted) return;

          this.setPhotos(this.state.photos.length + 1);
          this.animatePhotos();
        }
      }, 3000);
    }

    setPhotos(count) {
      const { allPhotos } = this.state;
      const photos = allPhotos.slice(allPhotos.length - count);
      this.setState({ photos: reverse ? photos.reverse() : photos });
    }

    componentWillUnmount() {
      this._isMounted = false;
    }

    render() {
      const { photos } = this.state;
      if (!photos || photos.length === 0) return null;
      return <Component {...this.props} photos={photos} />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/connectors/photosConnector.js